import { useContext, useMemo } from "react";
import { ControlContext } from "../ControlContext.jsx";

export default function ChangeDepths() {
  const {
    frameType,
    boxProfileDepth,
    borderThickness,
    glyphThickness,
    aluminumProfileDepth,
    floatProfileDepth,
    floatFinishDepth,
    glassThickness,
    glassInsert,
    faceMountBackType,
  } = useContext(ControlContext);

  const depths = useMemo(() => {
    // const glassInsert = 0.6;

    if (frameType === "Print") {
      return {
        printDepth: 0.2,
        borderDepth: 0.2,
      };
    } else if (frameType === "Box") {
      const calculatedPrintDepth =
        boxProfileDepth -
        glassThickness -
        glassInsert -
        glyphThickness -
        borderThickness;
      const calculatedBorderDepth = calculatedPrintDepth;
      const calculatedGlyphDepth =
        boxProfileDepth - glassThickness - glassInsert - glyphThickness;
      const calculatedGlassDepth =
        boxProfileDepth - glassInsert - glassThickness / 2;

      return {
        printDepth: calculatedPrintDepth,
        borderDepth: calculatedBorderDepth,
        glyphDepth: calculatedGlyphDepth,
        glassDepth: calculatedGlassDepth,
      };
    } else if (frameType === "Float") {
      const printDepth = floatProfileDepth - floatFinishDepth;
      const borderDepth = floatProfileDepth - floatFinishDepth;
      const dibondDepth = floatProfileDepth - floatFinishDepth;
      return {
        printDepth,
        borderDepth,
        dibondDepth,
      };
    } else if (frameType === "Aluminum") {
      const calculatedPrintDepth =
        aluminumProfileDepth - glassThickness - glassInsert - borderThickness;
      const calculatedBorderDepth = calculatedPrintDepth;
      const calculatedGlassDepth =
        aluminumProfileDepth - glassInsert - glassThickness / 2;

      return {
        printDepth: calculatedPrintDepth,
        borderDepth: calculatedBorderDepth,
        glassDepth: calculatedGlassDepth,
      };
    } else if (frameType === "Face Mount") {
      let spacer = 0;
      let dibond = 0;
      
      switch (faceMountBackType) {
        case "Dibond":
          spacer = 1.7;
          dibond = 0.3;
        break;
        case "Chromaluxe":
          spacer = 1.7;
          dibond = 0.1143;
        break;
      }
      const dibondDepth = spacer + dibond;
      const printDepth = spacer + dibond;
      const borderDepth = spacer + dibond;
      const glassDepth = spacer + dibond + glassThickness/2 + 0.02;
      return {
        dibondDepth,
        printDepth,
        borderDepth,
        glassDepth,
      };
    } else if (frameType === "Canvas") {
      return {
        printDepth: 0,
        borderDepth: 0,
      };
    }
  }, [
    frameType,
    boxProfileDepth,
    borderThickness,
    glyphThickness,
    aluminumProfileDepth,
    floatProfileDepth,
    floatFinishDepth,
    faceMountBackType,
  ]);

  return depths;
}
